import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, MessageCircle, Headphones, RotateCcw, User } from 'lucide-react';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const navItems = [
    { path: '/dashboard', icon: Home, label: 'Início' },
    { path: '/chat', icon: MessageCircle, label: 'Conversar' },
    { path: '/listening', icon: Headphones, label: 'Ouvir' },
    { path: '/flashcards', icon: RotateCcw, label: 'Revisar' },
    { path: '/settings', icon: User, label: 'Perfil' },
  ];

  const handleClick = (item) => {
    navigate(item.path);
  };

  const isActive = (path) => {
    if (path === '/chat') {
      return location.pathname.startsWith('/chat') || 
             location.pathname === '/scenarios' || 
             location.pathname.startsWith('/guided-lesson');
    }
    if (path === '/listening') {
      return location.pathname === '/listening';
    }
    return location.pathname === path;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-forest/10 z-50 safe-bottom" data-testid="bottom-nav">
      <div className="flex justify-around items-center h-16 max-w-lg mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <button
              key={item.path}
              onClick={() => handleClick(item)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                active ? 'text-forest' : 'text-stone hover:text-forest'
              }`}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <div className={`p-1.5 rounded-xl transition-colors ${active ? 'bg-lime/30' : ''}`}>
                <Icon className={`w-5 h-5 ${active ? 'stroke-[2.5]' : ''}`} />
              </div>
              <span className={`text-[10px] mt-0.5 ${active ? 'font-medium' : ''}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
